import React from 'react'

type Props = {
    className?: string
}

export const ConstructionIcon = (props: Props) => {
    const { className = "w-5 h-5" } = props
    return (
        <svg fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" className={className}>
            <rect x="2" y="6" width="20" height="8" rx="1"/>
            <path d="M17 14v7"/>
            <path d="M7 14v7"/>
            <path d="M17 3v3"/>
            <path d="M7 3v3"/>
            <path d="M10 14 2.3 6.3"/>
            <path d="m14 6 7.7 7.7"/>
            <path d="m8 6 8 8"/>
        </svg>
    )
}
